// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { BadgeCheck as RawBadgeCheck } from "lucide-react";
export const BadgeCheck = /* @__PURE__ */ createIcon(RawBadgeCheck, "BadgeCheck", 2);
